// extracted by mini-css-extract-plugin
module.exports = {"item":"item--18LHU","reverse":"reverse--35opW","textWrap":"textWrap--1hoMN","describe":"describe--kmcxY","imageWrap":"imageWrap--jIC6V"};